exports.ERROR = {
  OUT_OF_GAS: 'out of gas',
  STACK_UNDERFLOW: 'stack underflow',
  STACK_OVERFLOW: 'stack overflow',
  INVALID_JUMP: 'invalid JUMP',
  INVALID_OPCODE: 'invalid opcode',
  REVERT: 'revert',
  STATIC_STATE_CHANGE: 'static state change'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ganache-core/node_modules/ethereumjs-vm/lib/constants.js
// module id = 23
// module chunks = 0